import AddIcon from '@atlaskit/icon/glyph/add';
import styled from '@emotion/styled';
import { map } from 'lodash';
import React from 'react';
import { BundleData } from '../../utility';
import { PageHeaderLogo } from './page-header-logo';
import { PageHeaderSubtitle } from './page-header-subtitle';

type PageHeaderProps = {
  readonly bundleData: BundleData;
  readonly useDarkBackgroundMode: boolean;
};

export function PageHeader({
  bundleData,
  useDarkBackgroundMode
}: PageHeaderProps) {
  const headerBuffer: JSX.Element[] = [];
  map(bundleData.products, (productData) =>
    headerBuffer.push(PageHeaderLogo({ productData, useDarkBackgroundMode }))
  );
  if (headerBuffer.length > 1) {
    headerBuffer.splice(
      1,
      0,
      <PlusIcon>
        <AddIcon label="plusSign" key="plusSign" primaryColor="white" />
      </PlusIcon>
    );
    return (
      <Container>
        <HeaderContainerWithPlus>{headerBuffer}</HeaderContainerWithPlus>
        <PageHeaderSubtitle
          edition={bundleData.edition}
          useDarkBackgroundMode={useDarkBackgroundMode}
        />
      </Container>
    );
  }
  return (
    <Container>
      <HeaderContainer>{headerBuffer}</HeaderContainer>
      <PageHeaderSubtitle
        edition={bundleData.edition}
        useDarkBackgroundMode={useDarkBackgroundMode}
      />
    </Container>
  );
}

const Container = styled.div`
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
`;

const PlusIcon = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  display: inline-block;
  position: relative;
  bottom: 10px;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  svg,
  img {
    margin-bottom: 0px !important;
  }
`;
const HeaderContainerWithPlus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-bottom: 0px !important;
  }
`;
